import { DatetimeMonthFormat, FormatName, MonthFormat } from 'app/lib/datetime/types';

import type { SupportedLang } from 'app/lang';

export const MONTH_FORMATS: Record<DatetimeMonthFormat, MonthFormat> = {
  full: 'MMMM',
  short: 'MMM',
  oneLetter: 'MMMMM',
};

export const DATE_FORMATS = (
  month: MonthFormat,
): Record<SupportedLang, Record<FormatName, string>> => ({
  ru: {
    numeric: 'dd.MM.yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Только что',
  },
  en: {
    numeric: 'MM/dd/yyyy',
    numericWithTime: 'MM/dd/yyyy, h:mm a',
    time: 'h:mm a',
    timeWithSeconds: 'h:mm:ss a',
    short: `${month} dd`,
    shortWithYear: `${month} dd, yyyy`,
    long: `${month} dd, h:mm a`,
    longWithYear: `${month} dd, yyyy h:mm a`,
    // just: 'Just',
  },
  uz: {
    numeric: 'dd/MM/yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Hozirgina',
  },
  kk: {
    numeric: 'dd.MM.yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Жана ғана',
  },
  ky: {
    numeric: 'dd.MM.yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Азыр эле',
  },
  tg: {
    numeric: 'dd.MM.yyyy',
    numericWithTime: 'dd.MM.yyyy, HH:mm',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    short: `dd ${month}`,
    shortWithYear: `dd ${month} yyyy`,
    long: `dd ${month}, HH:mm`,
    longWithYear: `dd ${month} yyyy, HH:mm`,
    // just: 'Танҳо',
  },
});

export const FRIENDLY_DATE_FORMATS = {
  ru: {
    yesterday: {
      default: 'Вчера',
      withTime: "'Вчера в' HH:mm",
    },
    today: {
      default: 'Сегодня',
      withTime: "'Сегодня в' HH:mm",
    },
    tomorrow: {
      default: 'Завтра',
      withTime: "'Завтра в' HH:mm",
    },
  },
  en: {
    yesterday: {
      default: 'Yesterday',
      withTime: "'Yesterday at' h:mm a",
    },
    today: {
      default: 'Today',
      withTime: "'Today at' h:mm a",
    },
    tomorrow: {
      default: 'Tomorrow',
      withTime: "'Tomorrow at' h:mm a",
    },
  },
  uz: {
    yesterday: {
      default: 'Kecha',
      withTime: "'Kecha' HH:mm",
    },
    today: {
      default: 'Bugun',
      withTime: "'Bugun' HH:mm",
    },
    tomorrow: {
      default: 'Ertaga',
      withTime: "'Ertaga' HH:mm",
    },
  },
  kk: {
    yesterday: {
      default: 'Кеше',
      withTime: "'Кеше' HH:mm",
    },
    today: {
      default: 'Бүгін',
      withTime: "'Бүгін' HH:mm",
    },
    tomorrow: {
      default: 'Ертең',
      withTime: "'Ертең' HH:mm",
    },
  },
  ky: {
    yesterday: {
      default: 'Кечээ',
      withTime: "'Кечээ' HH:mm",
    },
    today: {
      default: 'Бүгүн',
      withTime: "'Бүгүн' HH:mm",
    },
    tomorrow: {
      default: 'Эртең',
      withTime: "'Эртең' HH:mm",
    },
  },
  // tg: {
  //   yesterday: {
  //     default: 'Дирӯз',
  //     withTime: "'Дирӯз' HH:mm",
  //   },
  //   today: {
  //     default: 'Имрӯз',
  //     withTime: "'Имрӯз' HH:mm",
  //   },
  //   tomorrow: {
  //     default: 'Пагоҳ',
  //     withTime: "'Пагоҳ' HH:mm",
  //   },
  // },
};
